import { shouldPolyfill as shouldPolyfillGetCanonicalLocales } from '@formatjs/intl-getcanonicallocales/should-polyfill';
import { shouldPolyfill as shouldPolyfillPluralRules } from '@formatjs/intl-pluralrules/should-polyfill';
import { shouldPolyfill as shouldPolyfillNumberFormat } from '@formatjs/intl-numberformat/should-polyfill';
// import { shouldPolyfill as shouldPolyfillDateTimeFormat } from '@formatjs/intl-datetimeformat/should-polyfill';
import { shouldPolyfill as shouldPolyfillRelativeTimeFormat } from '@formatjs/intl-relativetimeformat/should-polyfill';

/**
 * Dynamically polyfill Intl API & its locale data
 * @param locale locale to polyfill
 */
export async function polyfill(locale) {
  const dataPolyfills = [];
  // Polyfill Intl.getCanonicalLocales if necessary
  if (shouldPolyfillGetCanonicalLocales()) {
    /* webpackChunkName: "intl-getcanonicallocales" */
    await import('@formatjs/intl-getcanonicallocales/polyfill');
  }

  // Polyfill Intl.PluralRules if necessary
  if (shouldPolyfillPluralRules()) {
    /* webpackChunkName: "intl-pluralrules" */
    await import('@formatjs/intl-pluralrules/polyfill');
  }

  if (Intl.PluralRules.polyfilled) {
    const lang = locale.split('-')[0];
    switch (lang) {
      default:
        /* webpackChunkName: "intl-pluralrules" */
        dataPolyfills.push(import('@formatjs/intl-pluralrules/locale-data/en'));
        break;
      case 'it':
        /* webpackChunkName: "intl-pluralrules" */
        dataPolyfills.push(import('@formatjs/intl-pluralrules/locale-data/it'));
        break;
    }
  }

  // Polyfill Intl.NumberFormat if necessary
  if (shouldPolyfillNumberFormat()) {
    /* webpackChunkName: "intl-numberformat" */
    await import('@formatjs/intl-numberformat/polyfill');
  }

  if (Intl.NumberFormat.polyfilled) {
    switch (locale) {
      default:
        /* webpackChunkName: "intl-numberformat" */
        dataPolyfills.push(import('@formatjs/intl-numberformat/locale-data/en'));
        break;
      case 'it':
        /* webpackChunkName: "intl-numberformat" */
        dataPolyfills.push(import('@formatjs/intl-numberformat/locale-data/it'));
        break;
    }
  }

  // Polyfill Intl.DateTimeFormat if necessary
  // if (shouldPolyfillDateTimeFormat()) {
  /* webpackChunkName: "intl-datetimeformat" */
  await import('@formatjs/intl-datetimeformat/polyfill');
  // }

  if (Intl.DateTimeFormat.polyfilled) {
    dataPolyfills.push(import('@formatjs/intl-datetimeformat/add-all-tz'));
    switch (locale) {
      default:
        /* webpackChunkName: "intl-datetimeformat" */
        dataPolyfills.push(import('@formatjs/intl-datetimeformat/locale-data/en'));
        break;
      case 'it':
        /* webpackChunkName: "intl-datetimeformat" */
        dataPolyfills.push(import('@formatjs/intl-datetimeformat/locale-data/it'));
        break;
    }
  }

  // Polyfill Intl.RelativeTimeFormat if necessary
  if (shouldPolyfillRelativeTimeFormat()) {
    /* webpackChunkName: "intl-relativetimeformat" */
    await import('@formatjs/intl-relativetimeformat/polyfill');
  }

  if (Intl.RelativeTimeFormat.polyfilled) {
    switch (locale) {
      default:
        /* webpackChunkName: "intl-relativetimeformat" */
        dataPolyfills.push(import('@formatjs/intl-relativetimeformat/locale-data/en'));
        break;
      case 'it':
        /* webpackChunkName: "intl-relativetimeformat" */
        dataPolyfills.push(import('@formatjs/intl-relativetimeformat/locale-data/it'));
        break;
    }
  }

  await Promise.all(dataPolyfills);
}
